import { StyledForm } from "./FormStyles";

function FormView({ id, onSubmit, style, className, children }) {
  return (
    <StyledForm
      id={id}
      onSubmit={onSubmit}
      style={style}
      className={className}
      noValidate
    >
      {children}
    </StyledForm>
  );
}

export default FormView;
